pn-play-on-scroll {
  pn-scroll {
    [slot='scroll-affected'] {
      position: relative;
      display: flex;

      video {
        width: 100%;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
